import { render, staticRenderFns } from "./UnsubscribeQuiz.vue?vue&type=template&id=2db6589f"
import script from "./UnsubscribeQuiz.vue?vue&type=script&lang=js"
export * from "./UnsubscribeQuiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/devstark/spreadsimple/spreadsimple-app/main-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2db6589f')) {
      api.createRecord('2db6589f', component.options)
    } else {
      api.reload('2db6589f', component.options)
    }
    module.hot.accept("./UnsubscribeQuiz.vue?vue&type=template&id=2db6589f", function () {
      api.rerender('2db6589f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/subscription/unsubscription/UnsubscribeQuiz.vue"
export default component.exports